module.exports = __webpack_public_path__ + "img/avatar.a869bee2.svg";